export class SsoIntegrationSettings {
    'spEntityId';
    'ssoUrl';
    'sloUrl';
    'cognitoDomain';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "spEntityId",
            "baseName": "spEntityId",
            "type": "string",
            "format": ""
        },
        {
            "name": "ssoUrl",
            "baseName": "ssoUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "sloUrl",
            "baseName": "sloUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "cognitoDomain",
            "baseName": "cognitoDomain",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SsoIntegrationSettings.attributeTypeMap;
    }
    constructor() {
    }
}
